import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=7413ed61&"
import script from "./delete.js?vue&type=script&lang=js&"
export * from "./delete.js?vue&type=script&lang=js&"
import style0 from "./delete.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports